export enum DocumentActionState {
  Hidden = 'Hidden',
  Disabled = 'Disabled',
  Enabled = 'Enabled',
}

export interface DocumentModelStateActions {
  deleteDraft: DocumentActionState;
  startVerification: DocumentActionState;
  cancelVerification: DocumentActionState;
  approveVerification: DocumentActionState;
  declineVerification: DocumentActionState;
  retractVerification: DocumentActionState;
  sendForPublication: DocumentActionState;
  sendForPublicationEditorial: DocumentActionState;
  licenseeAdminSendToPublish: DocumentActionState;
  cancelPublication: DocumentActionState;
  declinePublication: DocumentActionState;
  publish: DocumentActionState;
  depublishByAdmin: DocumentActionState;
  depublishByCustomer: DocumentActionState;
  deregister: DocumentActionState;
  cancelDeregistration: DocumentActionState;
  startUpdate: DocumentActionState;
  cancelUpdate: DocumentActionState;
  generateRegistrationCertificate: DocumentActionState;
  editCollections: DocumentActionState;
}
